// sidecartsettingsReducer.js

import { SET_IPSCHECKOUT_SETTINGS } from '../../actions/settingsactions/settingsActions';

const initialState = {
  checkoutSettings: null,
};

const checkoutsettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_IPSCHECKOUT_SETTINGS:
      return {
        ...state,
        checkoutSettings: action.payload,
      };
    default:
      return state;
  }
};

export default checkoutsettingsReducer;